import { Box, Container, Stack } from '@hover/blueprint';
import React, { FC } from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import { ILinksGroup } from '../../../interfaces/ILinksGroup';
import FooterDesktop from './FooterDesktop';
import FooterMobile from './FooterMobile';
import { ILink } from '../../../interfaces/ILink';
import { FooterProps } from './types';

interface Props {
  linksDesktop: ILinksGroup;
  linksMobile: ILinksGroup;
  footerBottomItems: ILink[];
}

interface SiteData {
  site: {
    siteMetadata: {
      contact: FooterProps['contact'];
      copyright: string;
    };
  };
}

const Footer: FC<Props> = ({
  linksDesktop,
  footerBottomItems,
  linksMobile,
}) => {
  const {
    site: {
      siteMetadata: { contact, copyright },
    },
  } = useStaticQuery<SiteData>(graphql`
    query MyQuery {
      site {
        siteMetadata {
          contact {
            email
            phone
          }
          copyright
        }
      }
    }
  `);

  return (
    <footer>
      <Box
        bg="primary.900"
        pt={{ base: 900, tablet: '104px' }}
        overflowX="hidden"
      >
        <Box display={{ desktop: 'block', base: 'none' }} width="100%">
          <Container as={Stack} maxW="1232px" overflow="hidden">
            <FooterDesktop
              contact={contact}
              copyrightText={copyright}
              links={linksDesktop}
              footerBottomItems={footerBottomItems}
            />
          </Container>
        </Box>
        <Box display={{ desktop: 'none', base: 'flex' }} width="100%">
          <FooterMobile
            contact={contact}
            copyrightText={copyright}
            links={linksMobile}
            footerBottomItems={footerBottomItems}
          />
        </Box>
      </Box>
    </footer>
  );
};

export default Footer;
